import { render, staticRenderFns } from "./introLocation.vue?vue&type=template&id=6bf8ac7a"
import script from "./introLocation.vue?vue&type=script&lang=js"
export * from "./introLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports